<template>
    <el-dropdown
        size="small"
        placement="bottom-end"
        trigger="click"
        @command="handleOptUser"
    >
        <div class="opt_dialog">
            <div class="user-info">
                <el-image class="icon_user" :src="userAvatar"></el-image>
                <div :class="[this.$store.state.user.token ? 'username' : '']">
                    {{ userName }}
                </div>
                <div class="balance-info" v-if="token">
                    <img
                        src="@/assets/img/coin.png"
                        width="16"
                        height="16"
                        alt=""
                    />
                    <span class="balance-text">
                        {{ Number(currentAccount || 0) / payRate }}
                    </span>
                </div>
                <el-dropdown-menu slot="dropdown" class="header-new-drop">
                    <img
                        src="@/assets/img/menu/cirque.png"
                        width="150px"
                        style="position: absolute"
                    />
                    <div class="infoline">
                        <div class="username">
                            {{ curUserName }}
                        </div>
                        <div class="invite-code">
                            <span style="color: #9eaabd; font-size: 14px">
                                邀请码：
                            </span>
                            <el-tooltip placement="top">
                                <template #content>
                                    <div class="inviteCode-tooltip-content">
                                        <div>点击复制邀请码</div>
                                    </div>
                                </template>
                                <span
                                    v-clipboard:copy="curInviteCode"
                                    v-clipboard:success="copySucc"
                                >
                                    {{ curInviteCode }}
                                </span>
                            </el-tooltip>
                        </div>
                    </div>
                    <div
                        class="company-info"
                        v-if="curCompanyName && curCompanyName !== 'personal'"
                    >
                        <div class="name-wrap">
                            <img
                                src="@/assets/img/login/authComIcon.png"
                                style="margin-right: 5px; width: 22px"
                            />
                            <span>{{ curCompanyName }}</span>
                        </div>
                        <div class="role">{{ role }}</div>
                    </div>
                    <div
                        class="balance-details"
                        @click.stop="handlePushToCharge"
                    >
                        <div class="balance-header">
                            <img
                                src="@/assets/img/coin.png"
                                width="18"
                                height="18"
                                alt=""
                            />
                            <span class="balance-title">我的火币</span>
                        </div>
                        <div
                            class="balance-item"
                            v-for="item in accountInfoList"
                            :key="item.label"
                        >
                            <span class="balance-label">
                                {{ item.label }}：
                            </span>
                            <div class="balance-value">
                                <img
                                    v-if="item.showCoin"
                                    src="@/assets/img/coin.png"
                                    width="16"
                                    height="16"
                                    alt=""
                                />
                                <span>
                                    {{ formatAccountValue(item) }}
                                </span>
                            </div>
                        </div>
                        <div class="recharge-tip">点击充值 ></div>
                    </div>
                    <el-dropdown-item
                        v-for="item in displayOptuserInfo"
                        :command="item.command"
                        :key="item.command"
                    >
                        <img width="16" height="16" :src="item.img" />
                        <p style="margin-left: 10px">
                            {{ item.label }}
                        </p>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </div>
            <i class="el-icon-arrow-down"></i>
            <el-tooltip content="点我查看历史更新公告">
                <div class="version-list-btn" @click="openNoteDialog">
                    <i class="el-icon-message-solid"></i>
                </div>
            </el-tooltip>
        </div>
        <logout-dialog
            v-if="logoutDialogVisible"
            ref="LogoutDialog"
        ></logout-dialog>
        <switchId-dialog
            v-if="switchIdDialogVisible"
            ref="SwitchIdDialog"
        ></switchId-dialog>
    </el-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
import drowMenuList from "@/utils/drop-menu-list";
import LogoutDialog from "@/components/register/LogoutDialog";
import { checkRole } from "@/utils";
import SwitchIdDialog from "@/components/register/SwitchIdDialog";
import { payRate } from "@/utils/pay-data-list";
export default {
    components: { LogoutDialog, SwitchIdDialog },
    data() {
        return {
            OptuserInfo: drowMenuList,
            logoutDialogVisible: false,
            switchIdDialogVisible: false,
            payRate,
        };
    },
    computed: {
        ...mapGetters([
            "token",
            "loginId",
            "avatar",
            "username",
            "uAccount",
            "cAccount",
            "accountUser",
            "accountCompany",
        ]),
        userName() {
            return this.token && this.loginId == "personal"
                ? this.username
                : this.loginId;
        },
        userAvatar() {
            return this.token && this.avatar
                ? this.avatar
                : require("@/assets/img/icon_user.png");
        },
        curInviteCode() {
            return this.$store.state.user.inviteCode || "";
        },
        curUserName() {
            return this.username || "";
        },
        curCompanyName() {
            return this.loginId || "";
        },
        role() {
            if (this.$store.state.user.loginId === "personal") {
                return checkRole("admin") ? "管理员" : "用户";
            } else {
                return checkRole("Management") ? "管理员" : "普通员工";
            }
        },
        currentAccount() {
            return !this.loginId || this.loginId === "personal"
                ? this.uAccount
                : this.cAccount;
        },
        currentAccountInfo() {
            return !this.loginId || this.loginId === "personal"
                ? this.accountUser
                : this.accountCompany;
        },
        accountInfoList() {
            return !this.loginId || this.loginId === "personal"
                ? [
                      {
                          label: `账户余额`,
                          content: this.currentAccount || 0,
                          divisor: this.payRate,
                          showCoin: true,
                      },
                      {
                          label: `上海免费余额`,
                          content: this.currentAccountInfo?.freeBalance || 0,
                          divisor: this.payRate,
                          showCoin: true,
                      },
                      {
                          label: `宁波订阅免费额度`,
                          content: this.currentAccountInfo?.nbFreeBalance || 0,
                          divisor: this.payRate,
                          showCoin: true,
                      },
                      {
                          label: `宁波订阅套餐额度`,
                          content:
                              this.currentAccountInfo
                                  ?.nbBlnoPackageBalance || 0,
                          divisor: 1,
                          showCoin: true,
                      },
                  ]
                : [
                      {
                          label: `账户余额`,
                          content: this.currentAccount || 0,
                          divisor: this.payRate,
                          showCoin: true,
                      },
                      {
                          label: `宁波订阅套餐额度`,
                          content:
                              this.currentAccountInfo
                                  ?.nbBlnoPackageBalance || 0,
                          divisor: 1,
                          showCoin: true,
                      },
                  ];
        },
        displayOptuserInfo() {
            const items = [...this.OptuserInfo];
            if (checkRole("admin")) {
                items.splice(items.length - 1, 0, {
                    label: "宁波套餐管理",
                    command: "ningbo_quota_packages",
                    img: require("@/assets/img/menu/finance_select.png"),
                    route: "/ningboQuotaPackageManage",
                });
            }
            return items;
        },
    },
    methods: {
        formatAccountValue(item) {
            const value = Number(item.content || 0);
            const divisor = Number(item.divisor || 1);
            return Number.isFinite(value) ? value / divisor : 0;
        },
        openNoteDialog(e) {
            e.stopPropagation();
            this.$emit("openNoteDialog");
        },
        copySucc() {
            this.$message.success("复制成功");
        },
        showSwitchIdDialog() {
            this.switchIdDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.SwitchIdDialog.init();
            });
        },
        //个人导航栏转跳
        handleOptUser(index) {
            if (index === "switch_role") {
                //身份切换
                this.showSwitchIdDialog();
            } else if (index === "quit") {
                //退出登录
                this.logout();
            } else {
                const route = this.displayOptuserInfo.find(
                    (item) => item.command === index,
                ).route;
                this.$router.currentRoute.fullPath != route &&
                    this.$router.push(route);
            }
        },
        //退出登录
        logout() {
            this.logoutDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.LogoutDialog.init();
            });
        },
        handlePushToCharge() {
            this.$router.currentRoute.fullPath != "/pay/charge" &&
                this.$router.push("/pay/charge");
        },
    },
};
</script>
<style lang="stylus">
.el-popper.header-new-drop {
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background: linear-gradient(90deg, #DE6972 0%, rgba(222,105,114,0) 100%);
    color:#8B0505
  }
}
</style>
<style scoped lang="stylus">
.inviteCode-tooltip-content{
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;
}
.header-new-drop{
    padding:0 !important;
    background-image:url('../../../assets/img/menu/cirque.png')
    background: linear-gradient(180deg, #FFDFDF 0%, #FFFFFF 24%, #FFFFFF 100%);
    li {
        width: 320px;
        color: #9EAABD ;
        font-size:14px;
        line-height:20px;
        display:flex;
        align-items:center;
        position:relative;
        z-index:9999;
    }
    .infoline{
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        margin-top:20px;
        margin-bottom:10px;
        .invite-code{
            font-size: 14px;
            cursor: pointer;
        }

    }
    .username{
        font-size: 14px;
        line-height: 22px;
        font-family: Inter-Regular, Inter;
    }

    .company-info{
        color:#9EAABD
        font-size: 14px;
        line-height: 22px;
        margin-left:15px;
        margin-bottom:15px;
        font-family: Inter-Regular, Inter;
        height:22px;
        display:flex;
        justify-content: space-between;
        align-items:center;
        .name-wrap{
            display: flex;
            align-items: center;
            span{
                display: inline-block;
                max-width: 190px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space:nowrap;
            }
        }
        .role{
            font-size: 12px;
            padding:0 4px;
            border-radius: 3px;
            text-align:center;
            color:#A5220E;
            border: 1px solid #A5220E;
            margin-right:15px;
        }
    }

    .balance-details{
        padding: 15px;
        margin-bottom: 10px;
        background: linear-gradient(135deg, #FFF5F5 0%, #FFFFFF 100%);
        border-radius: 8px;
        margin-left: 15px;
        margin-right: 15px;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        z-index: 9999;
        &:hover{
            background: linear-gradient(135deg, #FFE8E8 0%, #FFF5F5 100%);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(222, 105, 114, 0.15);
        }
        .balance-header{
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            padding-bottom: 10px;
            border-bottom: 1px solid #FFE0E0;
            img{
                margin-right: 8px;
            }
            .balance-title{
                font-size: 15px;
                font-weight: bold;
                color: #A5220E;
            }
        }
        .balance-item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6px 0;
            .balance-label{
                color: #666;
                font-size: 13px;
            }
            .balance-value{
                display: flex;
                align-items: center;
                font-weight: bold;
                color: #333;
                font-size: 14px;
                img{
                    margin-right: 4px;
                }
            }
        }
        .recharge-tip{
            text-align: center;
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px solid #FFE0E0;
            color: #DE6972;
            font-size: 13px;
            font-weight: bold;
        }
    }

}

.opt_dialog {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: fit-content;
  padding: 0 1rem;
  z-index: 10;
    .user-info{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 4px 8px;
        border-radius: 20px;
        transition: all 0.3s ease;
        &:hover{
            background: linear-gradient(90deg, rgba(222,105,114,0.1) 0%, rgba(222,105,114,0.05) 100%);
        }
    }
    .icon_user {
        width: 30px;
        height: 30px;
        object-fit: cover;
        border-radius: 50%;
        background-color: #f2f2f2;
        flex-shrink: 0;
    }
    .username {
        max-width: 84px;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        color: #333333;
        font-size: 12px;
        line-height: 20px;
        font-weight: bold;
        height: 100%;
        margin: 0 4px 0 6px;
    }
    .balance-info{
        display: flex;
        align-items: center;
        margin-left: 8px;
        padding-left: 8px;
        border-left: 1px solid #e0e0e0;
        img{
            margin-right: 4px;
        }
        .balance-text{
            font-size: 14px;
            font-weight: bold;
            color: #A5220E;
        }
    }
    .el-icon-arrow-down{
        font-size: 12px;
        font-weight: bold;
        margin-left: 4px;
    }
    .version-list-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        margin-left: 12px;
        border-radius: 6px;
        background: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        transition: all 0.2s ease;
        flex-shrink: 0;
        i{
            font-size: 16px;
            color: #666;
            transition: all 0.2s ease;
        }
        &:hover{
            background: #fff;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
            i{
                color: #ff551f;
            }
        }
        &:active{
            transform: scale(0.95);
        }
    }
  }
</style>
